export default "__VITE_ASSET__DEHEnzuq__"